<template>
  <div class="custom-carousel-container">
    <!-- Element UI 轮播组件 -->
    <el-carousel
            ref="carousel"
            :autoplay="true"
            :interval="2000"
            :indicator-position="none"
            :arrow="hover"
            @change="handleCarouselChange"
    >
      <!-- 动态生成轮播面板：每个面板对应一次偏移 -->
      <el-carousel-item v-for="(panel, idx) in panelCount" :key="idx">
        <div class="carousel-panel">
          <!-- 横向排列所有图片（包含复制的部分，实现循环） -->
          <div
                  class="item-list"
                  :style="{ transform: `translateX(-${idx * itemWidth}px)` }"
          >
            <div class="carousel-item" v-for="(img, imgIdx) in loopImageList" :key="imgIdx" @click="goPage('news',15,img.id)">
              <img :src="$imgUrl+img.breviaryMap" alt="轮播图片" class="item-img" />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: ['list'],
  data() {
    return {
      arr: JSON.parse(this.list),
      listData: [],
      itemWidth: 295, // 单个item宽度（含间距）
      showCount: 4, // 一行显示的item数量
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.getData()
    });

  },
  computed: {
    // 循环图片列表：复制前4个item，实现无缝循环
    loopImageList() {
      return [...this.listData, ...this.listData.slice(0, this.showCount)];
    },
    // 轮播面板数量 = 原始图片数量（保证每次滚动1个item）
    panelCount() {
      return this.listData.length;
    },
  },
  methods: {
    // 处理轮播切换，实现循环
    handleCarouselChange(currentIndex) {
      // 当轮播到最后一个面板时，强制切回第0个（无动画）
      if (currentIndex === this.panelCount - 1) {
        setTimeout(() => {
          this.$refs.carousel.setActiveItem(0);
        }, 500); // 等待轮播动画完成后重置
      }
    },
    goPage(url, type, id) {
      this.$util.goTop()
      var params = {}
      if (type) {
        params.type = type
      }
      if (id) {
        params.id = id
      }
      this.$router.push({
        path: url,
        query: params
      })
    },
    getData() {
      // console.log(222,this.arr)
      if (this.arr.length > 0) {
        this.listData = this.arr;
      }
    }
  }

}
</script>
<style lang='scss' scoped>
.branchbox {
  position: relative;
  margin-top: 25px;
  margin-bottom: 25px;
}

.item {
  width: 25%;
  height: 118px;
  color: #333333;
  font-size: 14px;

  .imgbox {
    width: 100%;
    height: 100%;
    padding-right: 10px;
    position: relative;

    img {
      width: 100%;
      height: auto;
    }
  }

  .imgbox:nth-child(4) {
    padding-right: 0px;
  }

}

.el-carousel__item {
  .img {
    width: 100%;
  }
}

.imgbox:hover {
  > img {
    transform: scale(1.2);
  }
}

/* 轮播容器：宽度 = 4个item宽度之和 */
.custom-carousel-container {
  width: 100%; /* 4 × 200px */
  height: 170px;
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-carousel__arrow{
  top: 28%!important;
}

/* 轮播面板：铺满容器 */
.carousel-panel {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 图片列表：横向排列所有item */
.item-list {
  display: flex;
  transition: transform 0.5s ease; /* 平滑滚动 */
}

/* 单个item：固定宽度，包含间距 */
.carousel-item {
  width: 295px;
  padding: 5px;
  box-sizing: border-box;
  flex-shrink: 0; /* 防止item被压缩 */
}

/* 图片样式 */
.item-img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

/* 隐藏Element UI默认的指示器（可选） */
::v-deep .el-carousel__indicators {
  display: none;
}
</style>
